import {
	IMessageBoxResolvePayload,
	MessageBox,
	MessageBoxButton,
	MessageBoxButtons
} from '@bimser/common';
import { MLHelper } from '@bimser/core';
import { call } from 'redux-saga/effects';
import { IRunAction, runAction } from './runAction';
import { RuleEngineLegacyEntities } from '@bimser/components/dist/BCRuleManager';

export function* runShowConfirmationAction(
	action: RuleEngineLegacyEntities.IShowMessageAction,
	args: IRunAction
) {
	let result = false;

	const boxResponse: IMessageBoxResolvePayload = yield MessageBox.confirm({
		title: action.name,
		content: MLHelper.getMLText(action.messages),
		buttons: MessageBoxButtons.OKCancel
	});

	if (boxResponse) {
		switch (boxResponse.button.id) {
			case MessageBoxButton.OK: {
				if (action.approvalActions?.length) {
					const actionPromiseResults = yield call(runAction, {
						actions: action.approvalActions,
						rule: args.rule,
						checkType: args.checkType,
						windowId: args.windowId
					});
					result = actionPromiseResults.filter(Boolean).length > 0;
				}

				break;
			}
			case MessageBoxButton.Cancel: {
				if (action.rejectionActions?.length) {
					const actionPromiseResults = yield call(runAction, {
						actions: action.rejectionActions,
						rule: args.rule,
						checkType: args.checkType,
						windowId: args.windowId
					});
					result = actionPromiseResults.filter(Boolean).length > 0;
				}

				break;
			}
		}
	}

	return result;
}
